import { Routes, Route, Navigate } from 'react-router-dom'
import useTheme from './hooks/useTheme'
import useFavicon from './hooks/use-favicon'
import { AuthProvider } from './context/AuthProvider'
import { DataElementsProvider } from './context/DataElementsProvider'
import { ToastContext } from './context/ToastContext'
import useToast from './hooks/useToast'

import { ProtectedRoute } from '@/routes/ProtectedRoute'
import { PublicRoute } from './routes/PublicRoute'

import Layout from './layouts/Layout'
import LoginPage from './pages/LoginPage'
import NotFoundPage from './pages/NotFoundPage'
import ToastMini from './components/ToastMini'
import SubmittalsPage from './pages/Submittals/index'
import { SubmittalDetailPage } from './pages/Submittals/SubmittalDetailPage'

export default function App() {
  useTheme()
  useFavicon()
  const toast = useToast()

  return (
    <AuthProvider>
      <DataElementsProvider>
        <ToastContext.Provider value={toast}>
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />

            {/* Public */}
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <LoginPage />
                </PublicRoute>
              }
            />

            {/* Protected */}
            <Route element={<ProtectedRoute />}>
              <Route element={<Layout />}>
                <Route path="/submittals">
                  <Route index element={<SubmittalsPage />} />
                  {/* The listing scoped to one data element, which is what the
                      sidebar's sub-items link to. Three segments, so it never
                      collides with the detail page below — but the bare `de`
                      does, and would resolve to a detail page for a submittal
                      by that name. */}
                  <Route path="de" element={<Navigate to="/submittals" replace />} />
                  <Route path="de/:dataElementId" element={<SubmittalsPage />} />
                  <Route path=":submittalId" element={<SubmittalDetailPage />} />
                </Route>
              </Route>
            </Route>

            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <ToastMini />
        </ToastContext.Provider>
      </DataElementsProvider>
    </AuthProvider>
  )
}
